import { render, staticRenderFns } from "./logins.vue?vue&type=template&id=3f64978c&scoped=true&"
import script from "./logins.vue?vue&type=script&lang=js&"
export * from "./logins.vue?vue&type=script&lang=js&"
import style0 from "./logins.vue?vue&type=style&index=0&id=3f64978c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f64978c",
  null
  
)

export default component.exports